module.exports = __webpack_public_path__ + "img/already-interviewed.e820070e.svg";